
enum SiteNotificationType {
	ACTIVATE_PROVIDER = 'ACTIVATE_PROVIDER',
	EXPORT_MARKET_STATE = 'EXPORT_MARKET_STATE',
	EXPORT_PARITY = 'EXPORT_PARITY',
}

export default SiteNotificationType;
